import(/* webpackMode: "eager" */ "/home/interim/frontend/app/media/page.tsx");
